import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { ContentWithCardLoading } from "../../../../components/loading";
import AdvanceDataTable from "../../../../components/normal-table/advance-table";
import * as accountCampaignPricingWhatsappActions from "../../store/actions/account_campaign_pricing_whatsapp_actions";
import AccountCampaignPricingWhatsappSidePanel from "./components/account-campaign-pricing-whatsapp-side-panel";

const ACCOUNT_CAMPAIGN_PRICING_WHATSAPP_ACTIONS = {
  NONE: "NONE",
  EDIT: "EDIT",
};

export default function AccountCampaignPricingWhatsapp() {
  const [selectedPricingWithAction, setSelectedPricingWithAction] = useState({
    action: ACCOUNT_CAMPAIGN_PRICING_WHATSAPP_ACTIONS.NONE,
    data: {},
  });
  const accountCampaignPricingWhatsappList = useSelector((state) => state.accounts.accountCampaignPricingWhatsapp);
  const params = useParams();

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(accountCampaignPricingWhatsappActions.getPricingOfAccountWhatsappCampaignRequest({ id: params.accountId }));
  }, [dispatch, params.accountId]);

  return (
    <>
      {accountCampaignPricingWhatsappList.loading ? (
        <ContentWithCardLoading />
      ) : accountCampaignPricingWhatsappList.data.length === 0 ? (
        "No accounts"
      ) : (
        <div className={`card card-custom`}>
          <div className="card-body py-3 px-3" style={{ padding: 15 }}>
            <AdvanceDataTable
              columns={[
                { title: "Currency", apiKeyName: "currency", fieldInputType: "INPUT" },
                { title: "Price Per Whatsapp", apiKeyName: "price", fieldInputType: "INPUT" },
                { title: "Additional Price Per Whatsapp", apiKeyName: "addOnPrice", fieldInputType: "INPUT" },
                { title: "Final Price Per Whatsapp ", apiKeyName: "finalPrice", fieldInputType: "INPUT" },
                { title: "Actions", isAction: true, options: ["edit"] },
              ]}
              data={accountCampaignPricingWhatsappList.data.map((each) => ({
                ...each,
                finalPrice: ((each.addOnPrice || 0) + (each.price || 0)).toFixed(4)
              }))}
              limit={10}
              pageNo={1}
              count={1}
              // actions
              handleEdit={(data) => setSelectedPricingWithAction({ action: ACCOUNT_CAMPAIGN_PRICING_WHATSAPP_ACTIONS.EDIT, data })}
            />
          </div>
        </div>
      )}

      <AccountCampaignPricingWhatsappSidePanel
        show={selectedPricingWithAction.action === ACCOUNT_CAMPAIGN_PRICING_WHATSAPP_ACTIONS.EDIT}
        pricingData={selectedPricingWithAction.data}
        handleClose={() => setSelectedPricingWithAction({ action: ACCOUNT_CAMPAIGN_PRICING_WHATSAPP_ACTIONS.NONE, data: {} })}
      />
    </>
  );
}
